// Destek yönetimi menü rozeti (personel yanıtı bekleyen talep sayısı)
export const FETCH_SUPPORT_BADGE = "FETCH_SUPPORT_BADGE"
export const FETCH_SUPPORT_BADGE_SUCCESS = "FETCH_SUPPORT_BADGE_SUCCESS"
export const CLEAR_SUPPORT_BADGE = "CLEAR_SUPPORT_BADGE"

// Kullanıcı destek rozeti (kendi taleplerine gelen yanıt sayısı)
export const FETCH_MY_SUPPORT_BADGE = "FETCH_MY_SUPPORT_BADGE"
export const FETCH_MY_SUPPORT_BADGE_SUCCESS = "FETCH_MY_SUPPORT_BADGE_SUCCESS"
